import { SCORE_HEX } from "./score-colors";

interface ScoreDistributionProps {
  scores: number[];
}

const BUCKETS = [
  { min: 0, max: 10, label: "0–9" },
  { min: 10, max: 20, label: "10–19" },
  { min: 20, max: 30, label: "20–29" },
  { min: 30, max: 40, label: "30–39" },
  { min: 40, max: 50, label: "40–49" },
  { min: 50, max: 60, label: "50–59" },
  { min: 60, max: 70, label: "60–69" },
  { min: 70, max: 80, label: "70–79" },
  { min: 80, max: 90, label: "80–89" },
  { min: 90, max: 101, label: "90–100" },
];

function bucketColor(min: number): string {
  if (min >= 75) return SCORE_HEX.high;
  if (min >= 50) return SCORE_HEX.medium;
  return SCORE_HEX.low;
}

export function ScoreDistribution({ scores }: ScoreDistributionProps) {
  if (scores.length === 0) {
    return <p className="text-sm text-muted-foreground py-8 text-center">No scores to display.</p>;
  }

  // Single-pass bucketing instead of 10 filter passes
  const counts = BUCKETS.map((b) => ({ ...b, count: 0 }));
  for (const s of scores) {
    const idx = Math.min(Math.floor(s / 10), 9);
    const bucket = counts[idx];
    if (bucket) bucket.count += 1;
  }

  const maxCount = Math.max(...counts.map((c) => c.count), 1);

  return (
    <div className="space-y-1.5">
      {counts.map((bucket) => {
        const widthPct = (bucket.count / maxCount) * 100;
        return (
          <div key={bucket.label} className="flex items-center gap-2">
            <span className="w-12 text-xs text-muted-foreground text-right tabular-nums">
              {bucket.label}
            </span>
            <div className="flex-1 h-6 bg-muted rounded overflow-hidden">
              {bucket.count > 0 && (
                <div
                  className="h-full rounded transition-all"
                  style={{
                    width: `${Math.max(widthPct, 2)}%`,
                    backgroundColor: bucketColor(bucket.min),
                  }}
                />
              )}
            </div>
            <span className="w-8 text-xs font-medium text-right tabular-nums">{bucket.count}</span>
          </div>
        );
      })}
    </div>
  );
}
